import React from "react"
import { css } from "@emotion/react"
import styled from "@emotion/styled"

export const Label = styled(({ style, size, ...props }) => (
  <label {...props} />
))``
